// extracted by mini-css-extract-plugin
module.exports = {"fileInput":"dropZone_fileInput__2eCrq","dropZone":"dropZone_dropZone__34GCx","content":"dropZone_content__1BhzG","icon":"dropZone_icon__2L4AD","active":"dropZone_active__3XqKc"};